import moment from 'moment';

/**
 * Interface with ChiliPiper service that is sent from our Pardot forms
 * @param {Object} event
 */
export default function chiliPiper(event) {
  // If the message is not originating from `go.gremlin.com` we don't care about it
  if (event.origin !== 'https://go.gremlin.com') return;

  let parsedData;

  // We get multiple messages sent to our website from `go.gremlin.com` so this weeds out the ones that will not pass JSON parsing
  try {
    parsedData = JSON.parse(event.data);

    if (window.ChiliPiper && parsedData.email) {
      window.ChiliPiper.submit('gremlin', 'demo-request', {
        lead: {
          Email: parsedData.email,
          Chili_Piper_Date: moment().format('LLLL'),
        },
      });
    }
  } catch {
    return false;
  }
}
